import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  icon: {
    fontSize: 56,
  },
}));
